export default "./dist/stdassets/images/icons/forward.png";